// Component: MegaMenu
// Author: Mito Are
import * as React from 'react';
import MegaNav from '@component/MegaNav';
import WBRString from '@component/WbrString';
import { RoutableLink } from '../../react/RoutableLink';
import EditableLink from '../../react/EditableLink';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import i18n from 'i18next';

const getLinkList = (link) => {
  const rightFolder = link.fields?.children?.find((e) => e.name.toLowerCase() === 'right');
  const subNavLinkListTemplateId = '9e9283a5-90d7-43d3-88d8-5b10229a8b6a';
  const linkListFolder = rightFolder?.fields?.children?.find((e) => e.templateId === subNavLinkListTemplateId);
  const linkList = [];
  linkListFolder?.fields?.children?.map((l, i) => {
    linkList.push(
      <>
        <RoutableLink field={l.fields?.link} key={i}>
          <WBRString tag="span">
            <Text field={l.fields?.linktext} />
          </WBRString>
        </RoutableLink>
      </>
    );
  });
  return linkList;
};

const getLinkListTitle = (link) => {
  const rightFolder = link.fields?.children?.find((e) => e.name.toLowerCase() === 'right');
  const subNavLinkListTemplateId = '9e9283a5-90d7-43d3-88d8-5b10229a8b6a';
  const linkListFolder = rightFolder?.fields?.children?.find((e) => e.templateId === subNavLinkListTemplateId);
  return (
    <>
      <Text field={linkListFolder?.fields?.title} />
    </>
  );
};

const getMenuCards = (link, folderName, buttonClass) => {
  const folder = link.fields?.children?.find((e) => e.name.toLowerCase() === folderName);
  const subNavLinkTemplateId = '1eb2ad60-09cc-41b6-a44e-1f7f4493e7d0';
  const subNavLinks = folder?.fields?.children?.filter((e) => e.templateId === subNavLinkTemplateId);
  const linkList = [];
  subNavLinks?.map((l, i) => {
    linkList.push({
      title: <Text field={l.fields?.title} />,
      description: <Text field={l.fields?.copy} />,
      link: (
        <>
          <RoutableLink field={l.fields?.link} key={i} className={buttonClass}>
            {getLinkText(l.fields?.linktextoverride)}
          </RoutableLink>
        </>
      ),
    });
  });

  return linkList;
};

const getLinkText = (linktext) => {
  if (linktext?.value === '') return i18n.t('button/view') || 'View';
  return <Text field={linktext} />;
};

const MegaMenu = (props) => {
  const primaryLinksList = props.fields?.children;

  const mainLinksList = primaryLinksList?.filter((e) => e.fields?.otherlink?.value === false);
  const mainNav = [];
  mainLinksList?.map((link, i) => {
    const linklist = getLinkList(link);
    mainNav.push({
      // label: link.fields?.linktext.value,
      label: <Text field={link.fields?.linktext} />,
      href: link.fields?.link.value?.href,
      id: i,
      options: {
        linkOption: linklist?.length !== 0,
        linkOptionTitle: getLinkListTitle(link),
        optionLinks: linklist,
        Left: getMenuCards(link, 'left', 'button primary'),
        Right: getMenuCards(link, 'right', 'button secondary'),
      },
    });
  });

  const otherLinksList = primaryLinksList?.filter((e) => e.fields?.otherlink?.value === true);
  const navRightInfo = [];
  otherLinksList?.map((link, i) => {
    navRightInfo.push(
      <>
        <RoutableLink field={link.fields?.link} key={i}>
          <span className="nav_cta_text">
            <Text field={link.fields?.linktext} />
          </span>
          <button className="button_border">{i18n.t('button/view') || 'View'}</button>
        </RoutableLink>
      </>
    );
  });

  return (
    <>
      <MegaNav mainNav={mainNav} navRightInfo={navRightInfo} />
    </>
  );
};
export default MegaMenu;
